export const emailRegex = /^[^@]+@[^@]+\.[^@]+$/;

export const isEmailValid = (email: string): boolean => {
  return emailRegex.test(email);
};

/**
 * The domain part of an email — everything after the last `@`, e.g. `herman@playbk.io` → `playbk.io`.
 * Used to hand a third party (e.g. PostHog, for domain-targeted feature flags) only the domain, never
 * the identifiable address. Returns `undefined` when there's no domain (no `@`, or nothing after it)
 * so callers can skip sending it.
 */
export const getEmailDomain = (email: string): string | undefined => {
  const at = email.lastIndexOf('@');
  return at >= 0 && at < email.length - 1 ? email.slice(at + 1) : undefined;
};
